import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { formatCurrency } from "@sellar-io/common";
import { useState } from "react";
import { Icon } from "../../../components";
import { OrderEditItemEdit } from "./OrderEditItemEdit";

export const OrderEditItem = ({
  orderItem,
  currency,
  onDelete,
  onUpdate,
  setShowCheckoutIncreaseAlert,
}: {
  orderItem: OrderGetResponseType["OrderItems"][number];
  currency: OrderGetResponseType["currency"];
  onDelete: () => void;
  onUpdate: () => void;
  setShowCheckoutIncreaseAlert: (showCheckoutIncreaseAlert: boolean) => void;
}) => {
  const [isEditing, setIsEditing] = useState(false);

  if (isEditing)
    return (
      <OrderEditItemEdit
        orderItem={orderItem}
        onDelete={() => onDelete()}
        onCancel={() => setIsEditing(false)}
        onUpdate={() => {
          setIsEditing(false);
          onUpdate();
        }}
        setShowCheckoutIncreaseAlert={setShowCheckoutIncreaseAlert}
      />
    );

  return (
    <div
      className={
        "grid grid-cols-[40px_1fr_60px_auto] items-center gap-x-4 gap-y-2"
      }
    >
      <div>{orderItem.quantity}x</div>
      <div>{orderItem.Product.name}</div>
      <div>{formatCurrency(orderItem.price, currency)}</div>
      <div className={"cursor-pointer"} onClick={() => setIsEditing(true)}>
        <Icon icon={"PENCIL"} />
      </div>
    </div>
  );
};
